import React from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import SelectField from '../../fields/SelectField/SelectField';
import { ATTENDEE_VISIBILITY_FORM } from '../../constants/formNames';
import submitAttendeeVisibilityForm from '../../submit/submitAttendeeVisibilityForm';
import validateAttendeeVisibilityForm from '../../validate/validateAttendeeVisibilityForm';
import Button from '../../../../../elements-buttons/Button';
import { FormattedMessage, intlShape, injectIntl } from 'react-intl';

const AttendeeVisibilityForm = ({
  handleSubmit = () => {},
  isPatching = false,
  intl
}) => {
  const options = [
    { value: 'public',
      label: intl.formatMessage({
        id: 'invite.attendee_visibility_form.public_option',
        defaultMessage: 'Anyone with a link can view this page'
      }) },
    { value: 'private',
      label: intl.formatMessage({
        id: 'invite.attendee_visibility_form.private_option',
        defaultMessage: 'No one can view this page'
      }) }
  ];

  return (
    <form className="AttendeeVisibilityForm style-2" onSubmit={handleSubmit(submitAttendeeVisibilityForm)}>
      <div className="flex column">
        <h5 className="flex center">
          <FormattedMessage id="invite.attendee_visibility_form.title" defaultMessage="Visibility Settings"/>
        </h5>

        <p className="margin-lg-bottom">
          <FormattedMessage
            id="invite.attendee_visibility_form.subtitle"
            defaultMessage="You can choose to make this page visible and share it with your attendees, or make the page private."
          />
        </p>

        <Field
          className="flex margin-lg-bottom"
          inputClassName="flex-grow"
          component={SelectField}
          options={options}
          name="shareState"
          errorMessage={intl.formatMessage({
            id: 'invite.attendee_visibility_form.error_message',
            defaultMessage: 'Please enter a valid user name'
          })}
        />

        <Button
          category="primary"
          isLoading={isPatching}
        >
          <FormattedMessage id="invite.attendee_visibility_form.save" defaultMessage="Save"/>
        </Button>
      </div>
    </form>
  );
};

AttendeeVisibilityForm.propTypes = {
  handleSubmit: PropTypes.func,
  isPatching: PropTypes.bool,
  intl: intlShape
};

const config = {
  form: ATTENDEE_VISIBILITY_FORM,
  validate: validateAttendeeVisibilityForm
};

export default reduxForm(config)(injectIntl(AttendeeVisibilityForm));
